import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: resolve => require(["../components/Web_Skip.vue"], resolve)
    },

    {
      path: "/successPay/:payData", //<<<<<<<<<<<<<<<<<<<成功购买页面
      component: resolve => require(["../components/SuccessPay.vue"], resolve)
    },
    {
      path: "/cardPay", //<<<<<<<<<<<<<<<<<< 信用卡的单页支付
      component: resolve =>
        require(["../components/Stripe/Stripe.vue"], resolve)
    },
    //--------------------------------web---------------------------------------
    {
      path: "/login", //<<<<<<<<<<<<<<<<<< web登录页面
      component: resolve => require(["../components/Web_login.vue"], resolve)
    },
    {
      path: "/login/loginConfirm/:userName/:userId", //<<<<<<<<<<<<<<<<<<<loginConfirm
      component: resolve =>
        require(["../components/Web_loginConfirm.vue"], resolve)
    },
    {
      path: "/follow/:userName/:userId", //<<<<<<<<<<<<<<<<<<<follow
      component: resolve => require(["../components/Web_follow.vue"], resolve),
      name: "follow"
    },
    {
      path: "/like/:userName/:userId", //<<<<<<<<<<<<<<<<<<<like
      component: resolve => require(["../components/Web_like.vue"], resolve),
      name: "like"
    },
    {
      name: "posts",
      path: "/like/posts/:userName/:userId", //<<<<<<<<<<<<<<<<<<<like
      component: resolve => require(["../components/Web_posts.vue"], resolve)
    },
    {
      name: "subscription",
      path: "/subscription/:userName/:userId", //<<<<<<<<<<<<<<<<<<<like
      component: resolve =>
        require(["../components/Web_subscription.vue"], resolve)
    },
    {
      name: "subscriptionMonth",
      path: "/subscription/month/:userName/:userId", //<<<<<<<<<<<<<<<<<<<like
      component: resolve =>
        require(["../components/Web_subscriptionMonth.vue"], resolve)
    },
    {
      name: "more",
      path: "/more/:userName/:userId", //<<<<<<<<<<<<<<<<<<<like
      component: resolve => require(["../components/Web_more.vue"], resolve)
    },
    {
      name: "setting",
      path: "/more/setting/:userName/:userId", //<<<<<<<<<<<<<<<<<<<setting
      component: resolve => require(["../components/Web_setting.vue"], resolve)
    },
    {
      name: "settingFaq",
      path: "/more/setting/FAQ/:userName/:userId", //<<<<<<<<<<<<<<<<<<<FAQ
      component: resolve => require(["../components/Web_FAQ.vue"], resolve)
    },
    {
      name: "payment",
      path: "/payment", //<<<<<<<<<<<<<<<<<<payment
      component: resolve => require(["@/views/payment/payment.vue"], resolve)
    },
    {
      name: "settingFaqDetail",
      path: "/more/setting/FAQ/detail/:userName/:userId/:detailId", //<<<<<<<<<<<<<<<<<<<FAQ detail
      component: resolve =>
        require(["../components/Web_FAQ_detail.vue"], resolve)
    },
    {
      name: "paymentResult",
      path: "/paymentResult", //<<<<<<<<<<<<<<<<<<<payment Result
      component: resolve =>
        require(["../views/paymentResult/paymentResult.vue"], resolve)
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js